<template>
  <main class="cj-wrap" :style="{'background-image':`url(${controlInfo.backgroundImage})`}">
    <header class="header-top">
      <h1 :style="{
        color: controlInfo.titleFontColor,
        fontSize: controlInfo.titleFontSize + 'px'
      }">{{controlInfo.activityTitle}}</h1>
      <div class="rules" @click.stop="openRule">
        Reglas
      </div>
    </header>
    <header class="header-mobile">
<!--      <img src="@/assets/images/img-header-mobile.png" alt="" class="img">-->
    </header>
    <main class="cj-body-mobile">
      <div class="cj-box">
        <div class="countdown-outer commonStyle">
          <div class="countdown">
            <div class="title">Cuenta Para El Sorteo</div>
            <template v-if="selectAwardItem.drawType === 1">
              <!--            <van-loading type="spinner" color="#FF9329" v-if="isLottery" />-->
              <p class="curName" v-if="isLottery && curName !== ''">{{curName}}</p>
              <p class="count" v-if="nextItem.time && remainTime > 0 && selectAwardItem.surplusNum !== 0">
                <van-count-down :time="remainTime" @finish="handleFinish">
                  <template #default="timeData">
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.hours)" :key="index"
                      >{{ item }}</span>
                    </div>
                    <div class="colon">:</div>
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.minutes)" :key="index"
                      >{{ item }}</span>
                    </div>
                    <div class="colon">:</div>
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.seconds)" :key="index"
                      >{{ item }}</span>
                    </div>
                  </template>
                </van-count-down>
              </p>
              <!--            <p class="curName" v-if="selectAwardItem.surplusNum === 0">Event Concluded</p>-->
            </template>
            <template v-if="selectAwardItem.drawType === 0">
              <!--            <van-loading type="spinner" color="#FF9329" v-if="isLottery&&curName===''" />-->
              <p class="curName" v-if="isLottery">{{curName}}</p>
              <div class="btn" v-if="selectAwardItem.surplusNum !== 0 && isLottery" @click="handleStopLottery">Detener El Sorteo</div>
              <div class="btn" v-if="selectAwardItem.surplusNum !== 0 && !isLottery" @click="handleLottery">Participar Ahora</div>
              <!--            <p class="curName" v-if="selectAwardItem.surplusNum === 0">Event Concluded</p>-->
            </template>
          </div>
        </div>
        <div class="prize commonStyle" v-if="selectAwardItem.id">
          <div class="title">Premio De La Suerte</div>
          <div class="info">
            <img :src="selectAwardItem.img" alt="" class="pic">
            <p class="prize-name">{{ selectAwardItem.prizeName }}</p>
          </div>
          <div class="text">
            Esta Ronda Seleccionará <span>{{selectAwardItem.perNum}}</span> personas.
          </div>
        </div>
      </div>
      <div class="project-list commonStyle">
        <div class="title">Cuenta Para El Sorteo</div>
        <div class="swiper">
          <van-swipe
              class="my-swipe"
              :loop="false"
              :width="130"
              :show-indicators="false"
              indicator-color="white"
          >
            <van-swipe-item v-for="(item, index) in prizeList" :key="index">
              <div class="item-box">
                <div class="item" style="width: 120px;" @click="handleSelect(index)">
                  <div class="remain">Último {{item.surplusNum}}</div>
                  <img :src="item.img" alt="" class="pic">
                  <div class="rig">
<!--                    <p class="award">{{ item.awardName }}</p>-->
                    <p class="name">{{ item.prizeName }}</p>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="zj-list commonStyle">
        <div class="title">
          <span>Lista De Premios</span>
        </div>
        <div class="list" id="myList">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="No hay más datos"
              loading-text="En carga"
              @load="onLoad"
          >
            <div class="item" v-for="(item, index) in winList" :key="index">
              <div class="icon-prize-name">
                Nombre Del Premio
              </div>
              <div class="time">{{ item.createTime }}</div>
              <div class="item-top">
                <span class="name">{{ item.prizeName }}</span>

              </div>
              <p class="names">{{item.winnerNames.join(',')}}</p>
            </div>
          </van-list>
        </div>
      </div>
    </main>
    <main class="cj-body">
      <div class="cj-box">
        <div class="countdown-outer">
          <div class="countdown">
            <div class="title">Cuenta Para El Sorteo</div>
            <template v-if="selectAwardItem.drawType === 1">
              <!--            <van-loading type="spinner" color="#FF9329" v-if="isLottery" />-->
              <p class="curName" v-if="isLottery && curName !== ''">{{curName}}</p>
              <p class="count" v-if="nextItem.time && remainTime > 0 && !isLottery && selectAwardItem.surplusNum !== 0">
                <van-count-down :time="remainTime" @finish="handleFinish">
                  <template #default="timeData">
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.hours)" :key="index"
                      >{{ item }}</span>
                    </div>
                    <div class="colon">:</div>
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.minutes)" :key="index"
                      >{{ item }}</span>
                    </div>
                    <div class="colon">:</div>
                    <div style="display: flex;">
                      <span class="block"
                            v-for="(item, index) in splitArr(timeData.seconds)" :key="index"
                      >{{ item }}</span>
                    </div>
                  </template>
                </van-count-down>
              </p>
              <!--            <p class="curName" v-if="selectAwardItem.surplusNum === 0">Event Concluded</p>-->
            </template>
            <template v-if="selectAwardItem.drawType === 0">
              <!--            <van-loading type="spinner" color="#FF9329" v-if="isLottery && curName === ''" />-->
              <p class="curName" v-if="isLottery">{{curName}}</p>
              <div class="btn" v-if="selectAwardItem.surplusNum !== 0 && isLottery" @click="handleStopLottery">Detener el sorteo</div>
              <div class="btn" v-if="selectAwardItem.surplusNum !== 0 && !isLottery" @click="handleLottery">Participar Ahora</div>
              <!--            <p class="curName" v-if="selectAwardItem.surplusNum === 0">Event Concluded</p>-->
            </template>
          </div>
        </div>
        <div class="prize" v-if="selectAwardItem.id">
          <div class="title">Premio De La Suerte</div>
          <div class="info">
            <img :src="selectAwardItem.img" alt="" class="pic">
            <p class="prize-name">{{ selectAwardItem.awardName }}</p>
          </div>
          <div class="text">
            Esta Ronda Seleccionará <span>{{selectAwardItem.perNum}}</span> personas.
          </div>
        </div>
      </div>
      <div class="project">
        <div class="project-list">
          <div class="title">
            Cuenta Para El Sorteo
          </div>
          <div class="list" id="scrollX-list">
            <el-carousel :autoplay="false" arrow="always">
              <el-carousel-item v-for="(item,index) in Math.ceil(prizeList.length/4) || 1" :key="index">
                <div class="item-box" style="width: 100%;display: flex;">
                  <div class="item" v-for="(item1,index1) in prizeList.slice((item-1)*4,item*4)" :key="index1"
                       @click="handleSelect(index * 4 + index1)">
                    <div class="remain">Último {{item1.surplusNum}}</div>
                    <img :src="item1.img" alt="" class="pic">
                    <div class="info">
<!--                      <p class="award">{{ item1.awardName }}</p>-->
                      <p class="name">{{ item1.prizeName }}</p>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="zj-list">
        <div class="title">
          Lista De Premios
        </div>
        <div class="list" id="myList">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="No hay más datos"
              loading-text="En carga"
              @load="onLoad"
          >
            <div class="item" v-for="(item, index) in winList" :key="index">
              <div class="icon-prize-name">
                Nombre Del Premio
              </div>
              <p class="time">{{ item.createTime }}</p>
              <p class="name">{{ item.prizeName }}</p>
              <p class="zj-names">
                {{ item.winnerNames.join(',') }}
              </p>
            </div>
          </van-list>
        </div>
      </div>
    </main>
    <draw-rule :controlInfo="controlInfo" @close-rule="isRule = false;" v-if="isRule" />
    <big-win :result="result" :prizeName="prizeName" @close-result="closeResult" v-if="isResult" />
  </main>
</template>
<script setup>
import DrawRule from "@/components/DrawRule.vue";
import {ref, computed, onMounted} from "vue";
import CozyTip from "@/components/CozyTip.vue";
import BigWin from "@/components/BigWin.vue";
import {
  controlDetail,
  drawLottery,
  getGroupList,
  getNewRecord,
  lotteryGetAll,
  lotteryList,
  serverTime
} from "@/api/home";
import {transformTime} from "@/utils/transform";
const isTip = ref(false)
const splitArr = computed(() => {
  return (data) => {
    if(data < 10) {
      return [0, data]
    }else {
      return data.toString().split('')
    }
  }
})


/*
* 0.活动设置信息
* 奖项列表不用分页
* */
const audioBg = ref(null)
const audioZj = ref(null)
const controlInfo = ref({})
const getControlInfo = () => {
  controlDetail().then(res => {
    controlInfo.value = res
    // 设置标题
    document.title = res.activityTitle
    // audioBg.value = new Audio(controlInfo.value.backgroundSound)
    audioZj.value = new Audio(controlInfo.value.winningSound)
    // if(controlInfo.value.enableSound === '1') {
    //   const ua = navigator.userAgent;
    //   if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    //     document.addEventListener('touchstart', function () {
    //       // 2. 播放音频
    //       audioBg.value.play();
    //       audioBg.value.loop = true
    //     }, {once: true});
    //   }else {
    //     document.addEventListener('click', function() {
    //       audioBg.value.play();
    //       audioBg.value.loop = true
    //     }, { once: true });
    //   }
    // }
  }).catch(err => {})
}
getControlInfo()

/*
* 1.抽奖规则显示
* */
const isRule = ref(false)
const openRule = () => {
  isRule.value = true
}

/*
* 2.获取奖项列表
* 奖项列表不用分页
* */

const nextItem = ref({})
const getNextItem = () => {
  // 定时开奖的奖项，寻找下一轮待开奖的轮次
  if(selectAwardItem.value.drawType === 1) {
    nextItem.value = selectAwardItem.value.drawTimeList.find(item => {
      return item.status === 'pending'
    }) || {}
  }else {
    nextItem.value = {}
  }
}

const prizeList = ref([])
const selectAwardItem = ref({})
const getPrizeList = () => {
  lotteryGetAll().then(res => {
    // 获取奖项列表
    prizeList.value = res
    // 获取当前要显示的奖项
    if(res.length > 0) {
      // 如果没有当前奖项，则选第一个
      if(!selectAwardItem.value.id) {
        selectAwardItem.value = res[0]
      }else {
        // 如果有，当前奖项不变，但是由于抽奖后奖项剩余数据会变，则需要重新选中这个奖项，重新赋值
        selectAwardItem.value = res.find(item => {
          return selectAwardItem.value.id === item.id
        }) || {}
        // 增加下架功能，考虑到正好下架了当前奖项的情况
        if(!selectAwardItem.value.id) {
          selectAwardItem.value = res[0]
        }
      }
    }else {
      selectAwardItem.value = {}
    }
    // 获取当前奖项的组别人员，因为手动开奖需要滚动人员名单
    getGroupNames()
    // 针对当前奖项是定时开奖的情况，本轮自动抽奖完成，需要获取下一轮自动开奖时间，再进行倒计时
    getNextItem()
  }).catch(err => {})
}
const timeZone = ref({})
const getTimeZone = () => {
  serverTime().then(res => {
    timeZone.value = res
    getPrizeList()
  }).catch(err => {})
}
getTimeZone()



/*
* 3.获取中奖列表
* 中奖列表需要分页
* */
const winList = ref([])
const pageNo = ref(1)
const count = ref(0)
const initFinish = ref(false)
const loading = ref(true)
const finished = ref(false)
const lists = ref([])
const handleInit = () => {
  pageNo.value = 1
  count.value = 0
  loading.value = true
  finished.value = false
}
const getWinList = () => {
  lotteryList({
    pageNo: pageNo.value,
    pageSize: 10
  }).then(res => {
    winList.value = winList.value.concat(res.lists)
    initFinish.value = true
    count.value = res.count
    loading.value = false
  }).catch(err => {})
}
getWinList()
const onLoad = () => {
  if(pageNo.value === 0) {
    pageNo.value ++
    getWinList()
  }else{
    if(winList.value.length < count.value) {
      pageNo.value ++
      getWinList()
    }else{
      finished.value = true
    }
  }
}

/*
* 4.抽奖操作
* 手动开奖
* */
const prizeName = ref('')
const result = ref([])
const isLottery = ref(false)
const isResult = ref(false)
// 获取分组人员名单
const groupNames = ref([])
const getGroupNames = () => {
  if(selectAwardItem.value.surplusNum !== 0) {
    getGroupList({
      groupId: selectAwardItem.value.groupId
    }).then(res => {
      groupNames.value = res
    }).catch(err => {})
  }
}
const timer = ref(null)
const curName = ref('')
// 点击手动抽奖按钮，滚动分组人员名单
const handleLottery = () => {
  isLottery.value = true
  // let i = 0;
  timer.value = setInterval(() => {
    const i = Math.floor(Math.random() * groupNames.value.length)
    curName.value = groupNames.value[i].name
    // i++
    // if(i === groupNames.value.length - 1) {
    //   i = 0
    // }
  }, 50)
}
// 点击停止抽奖按钮，调用抽奖接口，显示抽奖结果
const handleStopLottery = () => {
  clearInterval(timer.value)
  timer.value = null
  curName.value = ''
  drawLottery({
    awardId: selectAwardItem.value.id
  }).then(res => {
    if(controlInfo.value.enableSound === '1') {
      // audioBg.value.pause();
      audioZj.value.play();
    }
    result.value = res
    if(res.length > 0) {
      prizeName.value = res[0].prizeImage
    }else {
      prizeName.value = ''
    }
    isLottery.value = false
    isResult.value = true
    getPrizeList()
    handleInit()
    lotteryList({pageNo: 1, pageSize: 10}).then(res => {
      winList.value = res.lists
      initFinish.value = true
      count.value = res.count
      loading.value = false
    }).catch(err => {})
  }).catch(err => {isLottery.value = false})
}

// 获取倒计时需要的剩余开奖毫秒数
// const remainTime = computed(() => {
//   const nowTime = new Date().getTime()
//   const lotteryTime = new Date(nextItem.value.time).getTime()
//   return lotteryTime - nowTime
// })
// 获取倒计时需要的剩余开奖毫秒数
const remainTime = computed(() => {
  const nowTime = transformTime(timeZone.value.timeZone)
  const lotteryTime = new Date(nextItem.value.time).getTime()
  return lotteryTime - nowTime
})

/*
* 5.抽奖操作
* 自动开奖
* */
const outTimer = ref(null)
const handleFinish = () => {
  handleLottery()
  outTimer.value = setTimeout(() => {
    clearInterval(timer.value)
    timer.value = null
    curName.value = ''
    getNewRecord({
      awardId: selectAwardItem.value.id
    }).then(res => {
      result.value = res.winnerNames
      prizeName.value = selectAwardItem.value.img
      if(controlInfo.value.enableSound === '1') {
        audioZj.value.play();
        // audioBg.value.pause();
      }
      isLottery.value = false
      isResult.value = true
      clearTimeout(outTimer.value)
      outTimer.value = null
      getPrizeList()
      lotteryList({pageNo: 1, pageSize: 10}).then(res => {
        handleInit()
        winList.value = res.lists
        count.value = res.count
        loading.value = false
      }).catch(err => {})
    }).catch(err => {})
  }, 3000)
}

// 点击切换当前奖项
const handleSelect = (index) => {
  document.getElementById('myList').scrollTop = 0
  clearTimeout(outTimer.value)
  outTimer.value = null
  clearInterval(timer.value)
  timer.value = null
  curName.value = ''
  selectAwardItem.value = prizeList.value[index]
  getPrizeList()
  lotteryList({pageNo: 1, pageSize: 10}).then(res => {
    handleInit()
    winList.value = res.lists
    count.value = res.count
    loading.value = false
  }).catch(err => {})
}

// 关闭中奖结果
const closeResult = () => {
  isResult.value = false
  audioZj.value.pause()
  // audioBg.value.play()
}


// onMounted(() => {
//   const container = document.getElementById('scrollX-list');
//   container.addEventListener('wheel', (evt) => {
//     evt.preventDefault();
//     container.scrollLeft += evt.deltaY; // 将垂直滚动量赋值给水平滚动
//   });
// })
</script>
<style scoped lang="scss">
:deep(.van-swipe-item:last-child .item-box .item) {
 width: 100% !important;
}
.cj-wrap {
  background: url("@/assets/images/bg-body.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: top center;
}
.header-top {
  width: 100%;
  height: 140px;
  position: relative;
  margin-bottom: 30px;
  h1 {
    color: rgb(252, 227, 138);
    font-size: 60px;
    line-height: 140px;
    text-align: center;
  }
  .rules {
    width: 184px;
    height: 66px;
    text-align: center;
    line-height: 66px;
    background: url("@/assets/images/bg-remain.png") center center no-repeat;
    background-size: 100% 100%;
    font-size: 24px;
    color: #FAFAFA;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }
}
.cj-body {
  width: 100%;
  height: 940px;
  display: flex;
  justify-content: space-between;
  padding: 0 50px 60px;
  .project {
    width: 820px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .project-list {
    width: 820px;
    height: 424px;
    border-radius: 20px;
    position: relative;
    padding-top: 100px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
    border: 2px solid #FFFFFF;
    box-shadow: 0px 4px 20px 0px #FFFFFFCC;
    backdrop-filter: blur(20px);
    .list {
      height: calc(100% - 40px);
      //padding: 0 80px;
      //display: flex;
      overflow: hidden;
      //overflow-x: auto;
      ///* 针对 Firefox 浏览器 */
      //scrollbar-width: none;
      ///* 针对 IE 和 Edge 浏览器 */
      //-ms-overflow-style: none;
      ///* 针对 Chrome、Safari 和 Opera 浏览器 */
      //::-webkit-scrollbar {
      //  display: none; /* 完全隐藏滚动条 */
      //}
    }
  }
  .zj-list {
    width: 476px;
    height: 880px;
    border-radius: 20px;
    position: relative;
    padding-top: 60px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
    border: 2px solid #FFFFFF;
    box-shadow: 0px 4px 20px 0px #FFFFFFCC;

    backdrop-filter: blur(20px);
    .list {
      height: calc(100% - 40px);
      padding: 12px;
      overflow: hidden;
      overflow-y: auto;
      /* 针对 Firefox 浏览器 */
      scrollbar-width: none;
      /* 针对 IE 和 Edge 浏览器 */
      -ms-overflow-style: none;
      /* 针对 Chrome、Safari 和 Opera 浏览器 */
      ::-webkit-scrollbar {
        display: none; /* 完全隐藏滚动条 */
      }
      .item {
        padding: 8px 12px;
        background: #ffffff;
        border-radius: 12px;
        margin-bottom: 12px;
        position: relative;
      }
    }
  }
  .project-list .item {
    width: 25%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 20px;
    box-sizing: border-box;
    &:last-child {
      padding-right: 0;
    }
    .pic {
      width: 120px;
      height: 120px;
      margin-bottom: 16px;
      border-radius: 12px;
      background-color: #ffffff;
    }
    .award {
      font-size: 16px;
      color: #003C64;
      line-height: 24px;
      text-align: center;
    }
    .name {
      font-size: 22px;
      //line-height: 30px;
      font-weight: 500;
      color: #003C64;
      text-align: center;
    }
    .remain {
      width: 150px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 14px;
      color: #ffffff;
      background: url('@/assets/images/bg-remain.png') center center no-repeat;
      background-size: 100% 100%;
      margin-bottom: 15px;
    }
  }
  .zj-list .list .item {
    padding-top: 10px;
    .icon {
      width: 100px;
      height: 40px;
      position: absolute;
      top: 10px;
      left: -5px;
    }
    .icon-prize-name {
      width: 146px;
      height: 31px;
      position: absolute;
      top: 10px;
      left: 0;
      background: #339DD7;
      font-size: 14px;
      color: #fff;
      line-height: 31px;
      padding-left: 10px;
      box-sizing: border-box;
      border-radius: 0 4px 12px 0;
    }
    .time {
      text-align: right;
      font-size: 16px;
      color: #339DD7;
      line-height: 31px;
      margin-bottom: 10px;
    }
    .name {
      font-size: 22px;
      color: #339DD7;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .zj-names {
      font-size: 18px;
      color: #387494;
      line-height: 22px;
      word-break: break-all;
      margin-top: 12px;
    }
  }
  .cj-box {
    width: 476px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .prize {
      width: 476px;
      height: 424px;
      border-radius: 12px;
      position: relative;
      padding-top: 100px;
      background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
      border: 2px solid #FFFFFF;
      box-shadow: 0px 4px 20px 0px #FFFFFFCC;
      backdrop-filter: blur(20px);
      box-sizing: border-box;
      .info {
        margin: 0 auto;
        text-align: center;
        .prize-name {
          font-size: 24px;
          color: #003C64;
        }
        .pic {
          width: 160px;
          height: 160px;
          border-radius: 14px;
          background-color: #fff;
          margin-bottom: 20px;
        }
      }
      .text {
        font-size: 20px;
        margin-top: 15px;
        color: #003C64;
        text-align: center;
        span {
          font-size: 28px;
          color: #1C78FF;
          font-weight: bold;
        }
      }
    }
    .countdown-outer {
      width: 476px;
      height: 350px;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      box-sizing: border-box;
      background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
      border: 2px solid #FFFFFF;
      box-shadow: 0px 4px 20px 0px #FFFFFFCC;
      backdrop-filter: blur(20px);
    }
    .countdown {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .count {
        color: #003C64;
        font-size: 148px;
        font-weight: bold;
      }
      :deep(.van-count-down) {
        color: #003C64;
        font-size: 60px;
        font-weight: bold;
        line-height: 1;
        display: flex;
        align-items: center;
      }
      .curName{
        color: #003C64;
        font-size: 64px;
        font-weight: bold;
        text-align: center;
      }
      .btn {
        width: 293px;
        height: 75px;
        background: url("@/assets/images/bg-title-btn1.png") center center no-repeat;
        background-size: 100% 100%;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        line-height: 75px;
        font-weight: bold;
        margin-top: 20px;
      }
      .btn1 {
        background: url("@/assets/images/bg-title-btn2.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.header-mobile {
  display: none;
}
.cj-body-mobile {
  display: none;
}
@media screen and (max-width: 768px) {
  .cj-wrap {
    padding: 0 4% 30px;
  }
  .header-top {
    display: none;
  }
  .header-mobile {
    display: block;
    height: 200px;
    //background: url("@/assets/images/bg-body-mobile.png") top center no-repeat;
    //background-size: 100% auto;
    //margin: 0 -4%;
    img {
      width: 100%;
      height: auto;
    }
  }
  .cj-body {
    display: none;
  }
  .cj-body-mobile {
    display: block;
    .project-list {
      width: 100%;
      position: relative;
      padding: 57px 16px 0;
      box-sizing: border-box;
      margin-top: 57px;
      .swiper {
        overflow: hidden;
        padding-bottom: 20px;
      }
      .item {
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        .pic {
          width: 120px;
          height: 120px;
          border-radius: 12px;
          background-color: #fff;
          margin-bottom: 10px;
        }
        .remain {
          display: block;
          width: 116px;
          height: 42px;
          text-align: center;
          line-height: 42px;
          background: url("@/assets/images/bg-remain.png") center center no-repeat;
          background-size: 100% 100%;
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 15px;
        }
        .rig {
          color: #003C64;
          .award {
            font-size: 12px;
            margin-bottom: 5px;
          }
          .name {
            font-size: 14px;
          }
        }
      }
    }
    .cj-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .prize {
        width: 100%;
        margin-top: 57px;
        padding: 50px 0 20px;
        .info {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          .prize-name {
            font-size: 14px;
            color: #003C64;
          }
          .pic {
            width: 120px;
            height: 120px;
            background-color: #fff;
            border-radius: 12px;
            margin-bottom: 12px;
          }
        }
        .text {
          font-size: 12px;
          color: #003C64;
          text-align: center;
          span {
            font-size: 16px;
            font-weight: bold;
            color: #1C78FF;
          }
        }
      }
      .countdown-outer {
        width: 100%;
        height: 279px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .countdown {
        width: 100%;
        height: 217px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .count {
          color: #003C64;
          font-size: 48px;
          font-weight: bold;
        }
        :deep(.van-count-down) {
          color: #003C64;
          font-size: 48px;
          font-weight: bold;
          line-height: 1;
          display: flex;
          align-items: center;
        }
        .curName{
          color: #003C64;
          font-size: 48px;
          font-weight: bold;
          text-align: center;
        }
        .btn {
          width: 240px;
          height: 80px;
          background: url("@/assets/images/bg-title-btn1.png") center center no-repeat;
          background-size: 100% 100%;
          font-size: 15px;
          color: #ffffff;
          text-align: center;
          line-height: 80px;
          font-weight: bold;
          margin-top: 20px;
        }
        .btn1 {
          background: url("@/assets/images/bg-title-btn4.png") center center no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .zj-list {
      padding: 50px 12px 12px;
      box-sizing: border-box;
      border-radius: 20px;
      margin-top: 57px;
      position: relative;
      .list {
        height: 880px;
        overflow: hidden;
        overflow-y: auto;
        /* 针对 Firefox 浏览器 */
        scrollbar-width: none;
        /* 针对 IE 和 Edge 浏览器 */
        -ms-overflow-style: none;
        /* 针对 Chrome、Safari 和 Opera 浏览器 */
        ::-webkit-scrollbar {
          display: none; /* 完全隐藏滚动条 */
        }
        .item {
          margin-top: 8px;
          background-color: #ffffff;
          border-radius: 12px;
          padding: 10px 10px 10px;
          position: relative;
          .icon {
            width: 78px;
            height: 30px;
            position: absolute;
            top: 8px;
            left: -4px;
          }
          .icon-prize-name {
            width: 146px;
            height: 31px;
            position: absolute;
            top: 10px;
            left: 0;
            background: #339DD7;
            font-size: 14px;
            color: #fff;
            line-height: 31px;
            padding-left: 10px;
            box-sizing: border-box;
            border-radius: 0 4px 12px 0;
          }
          .item-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 16px;
              color: #339dd7;
            }
          }
          .time {
            width: 100%;
            font-size: 14px;
            color: #339DD7;
            font-weight: bold;
            text-align: right;
            line-height: 31px;
            margin-bottom: 5px;
          }
          .names {
            line-height: 16px;
            color: #387494;
            font-size: 14px;
            margin-top: 5px;
            word-break: break-all;
          }
        }
      }
    }
  }
}
:deep(.van-swipe) {
  overflow: visible;
}
:deep(.van-swipe__indicators) {
  bottom: -25px;
  z-index: 999;
}
:deep(.van-swipe__indicator) {
  width: 8px;
  height: 8px;
  background-color: rgba(57, 166, 77, 0.5);
;
  margin-right: 5px !important;
}
:deep(.van-swipe__indicator--active) {
  width: 16px;
  height: 8px;
  border-radius: 4px;
  background-color: #39A64D !important;
}

.block {
  display: block;
  width: 56px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #003C64;
  background: #ffffff;
  position: relative;
  border-radius: 4px;
  &:first-child {
    margin-right: 12px;
  }
}
.colon {
  color: #ffffff;
  margin: 0 10px;
}
@media screen and (max-width: 768px) {
  .block {
    width: 38px;
    height: 85px;
    &:first-child {
      margin-right: 5px;
    }
  }
  .colon {
    margin: 0 5px;
  }
}
.commonStyle {
  background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
  border: 2px solid #FFFFFF;
  box-shadow: 0px 4px 20px 0px #FFFFFFCC;
  backdrop-filter: blur(20px);
}
@media screen and (max-width: 768px) {
  .commonStyle {
    border-radius: 12px;
  }
}
.title {
  width: 405px;
  height: 74px;
  background: url("@/assets/images/bg-title-btn.png") center center no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 74px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
}
@media screen and (max-width: 768px) {
  .title {
    width: 266px;
    height: 62px;
    line-height: 62px;
    top: -20px;
    font-size: 16px;
  }
}
:deep(.el-carousel) {
  height: 100%;
  padding: 0 80px;
}
:deep(.el-carousel__container) {
  width: 100%;
}
:deep(.el-carousel__item) {
  width: 100% !important;
}
:deep(.el-carousel__indicators) {
  display: none;
}

:deep(.el-carousel__arrow) {
  width: 42px;
  height: 84px;
  border-radius: 0;
}
:deep(.el-carousel__arrow--left) {
  background: url('@/assets/images/arrow-left.png');
  background-size: 100% 100%;
  left: 30px;
}
:deep(.el-carousel__arrow--right) {
  background: url('@/assets/images/arrow-right.png');
  background-size: 100% 100%;
  right: 30px;
}
</style>
